import { Reveal } from "./Reveal";
import { buildWaLink } from "../constants/site";
import { Snowflake, PowerOff, Droplets, Volume2, CircuitBoard, ArrowUpRight } from "lucide-react";

const DEFECTS = [
    {
        slug: "nao-gela",
        icon: Snowflake,
        title: "Não gela",
        desc: "Freezer ou parte de baixo sem refrigeração.",
        msg: "Olá preciso de uma visita técnica, minha geladeira não gela",
    },
    {
        slug: "nao-liga",
        icon: PowerOff,
        title: "Não liga",
        desc: "Nem luz, nem motor: nenhum sinal de vida.",
        msg: "Olá preciso de uma visita técnica, minha geladeira não liga",
    },
    {
        slug: "vazamento",
        icon: Droplets,
        title: "Vazamento",
        desc: "Água acumulando dentro ou embaixo da geladeira.",
        msg: "Olá preciso de uma visita técnica, minha geladeira está vazando água",
    },
    {
        slug: "barulho",
        icon: Volume2,
        title: "Barulho",
        desc: "Ruídos estranhos ao ligar, desligar ou durante o uso.",
        msg: "Olá preciso de uma visita técnica, minha geladeira está fazendo muito barulho",
    },
    {
        slug: "eletronica",
        icon: CircuitBoard,
        title: "Problemas eletrônicos",
        desc: "Painel, sensores ou placa eletrônica com falha.",
        msg: "Olá preciso de uma visita técnica, minha geladeira tem problema na placa eletrônica",
    },
];

export const Defects = () => (
    <section
        id="defeitos"
        className="scroll-mt-24 relative noise bg-graphite py-20 sm:py-28 overflow-hidden"
        data-testid="defects-section"
    >
        <div
            className="absolute top-0 left-1/4 w-[560px] h-[560px] rounded-full blur-3xl pointer-events-none opacity-40"
            style={{ background: "radial-gradient(circle, rgba(255,121,0,0.18) 0%, transparent 65%)" }}
            aria-hidden="true"
        />
        <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
            <Reveal>
                <p className="font-technical font-semibold uppercase tracking-[0.2em] text-sm text-brand">
                    Defeitos mais comuns
                </p>
                <h2 className="mt-3 max-w-2xl font-display font-black tracking-tight text-3xl sm:text-5xl text-white leading-tight">
                    Sua geladeira apresenta algum desses sintomas?
                </h2>
            </Reveal>

            <div className="mt-10 sm:mt-14 grid sm:grid-cols-2 lg:grid-cols-6 gap-5">
                {DEFECTS.map((d, i) => {
                    const Icon = d.icon;
                    const span = i < 3 ? "lg:col-span-2" : "lg:col-span-3";
                    return (
                        <Reveal key={d.slug} delay={i * 0.07} className={`h-full ${span}`}>
                            <a
                                href={buildWaLink(d.msg)}
                                target="_blank"
                                rel="noopener noreferrer"
                                data-testid={`defect-card-${d.slug}`}
                                className="group flex flex-col h-full rounded-3xl border border-white/10 bg-white/[0.05] p-6 sm:p-7 transition-all duration-300 hover:border-brand/60 hover:bg-white/[0.09] hover:-translate-y-1"
                            >
                                <div className="flex items-center justify-between">
                                    <span className="inline-flex items-center justify-center w-12 h-12 rounded-2xl bg-brand/15 text-brand">
                                        <Icon className="w-6 h-6" />
                                    </span>
                                    <ArrowUpRight className="w-5 h-5 text-white/30 transition-all duration-300 group-hover:text-brand group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                                </div>
                                <h3 className="mt-5 font-display font-bold text-xl text-white">{d.title}</h3>
                                <p className="mt-2 text-sm text-white/60 leading-relaxed">{d.desc}</p>
                                <span className="mt-5 font-display font-semibold text-sm text-white/80 group-hover:text-white transition-colors">
                                    Chamar no WhatsApp <span className="text-brand">→</span>
                                </span>
                            </a>
                        </Reveal>
                    );
                })}
            </div>
        </div>
    </section>
);
